import React from 'react';
import {useNavigate} from "react-router-dom";
import MobileLogoBlock from "../MobileLogoBlock";

const MobileLoginForm = ({ email, setEmail, password, setPassword, showPassword, setShowPassword, loading, error, handleSubmit, termsCheck, setTermsCheck }) => {
  const navigate = useNavigate();

  return (
      <div className="login-main">
        <MobileLogoBlock />
        <div className="login-main-header text-center mb-4">
          <div className="login-avatar-container mx-auto mb-3">
            <div className="login-avatar-outer mx-auto">
              <div className="login-avatar-inner mx-auto">
                <svg width="41" height="41" viewBox="0 0 41 41" className="login-avatar-image" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M20.4375 17.0312C24.1999 17.0312 27.25 13.9812 27.25 10.2188C27.25 6.45631 24.1999 3.40625 20.4375 3.40625C16.6751 3.40625 13.625 6.45631 13.625 10.2188C13.625 13.9812 16.6751 17.0312 20.4375 17.0312Z"
                      stroke="#404040" stroke-width="2.55469"/>
                  <path
                      d="M34.0591 30.6562C34.0614 30.3769 34.0625 30.0931 34.0625 29.8047C34.0625 25.5724 27.9619 22.1406 20.4375 22.1406C12.9131 22.1406 6.8125 25.5724 6.8125 29.8047C6.8125 34.037 6.8125 37.4688 20.4375 37.4688C24.2372 37.4688 26.9775 37.2014 28.9531 36.7245"
                      stroke="#404040" stroke-width="2.55469" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </div>

          <h2 className="login-title mb-3">Добро пожаловать!</h2>

          <p className="login-description">
            Для входа в личный кабинет
            <a href="#" className="login-link-text"> Партнер Лидс </a>
            введите ваши логин и пароль, полученные после заключения договора
          </p>
        </div>

        <div className="login-form">
          {error && <div className="login-error mb-3">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="login" className="form-label">Почта</label>
              <div className="input-group">
                <div className="password-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.66667 10C1.66667 6.8575 1.66667 5.28584 2.64334 4.31C3.62001 3.33417 5.19084 3.33334 8.33334 3.33334H11.6667C14.8092 3.33334 16.3808 3.33334 17.3567 4.31C18.3325 5.28667 18.3333 6.8575 18.3333 10C18.3333 13.1425 18.3333 14.7142 17.3567 15.69C16.38 16.6658 14.8092 16.6667 11.6667 16.6667H8.33334C5.19084 16.6667 3.61917 16.6667 2.64334 15.69C1.66751 14.7133 1.66667 13.1425 1.66667 10Z"
                        stroke="#404040"/>
                    <path
                        d="M5 6.66664L6.79917 8.16664C8.33 9.44164 9.095 10.0791 10 10.0791C10.905 10.0791 11.6708 9.44164 13.2008 8.16581L15 6.66664"
                        stroke="#404040" stroke-linecap="round"/>
                  </svg>
                </div>
                <input
                    type="text"
                    className="form-control"
                    id="login"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="E-mail"
                    disabled={loading}
                />
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">Пароль</label>
              <div className="input-group">
                <div className="password-icon login-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.625 12.2917C0.625 9.93505 0.625 8.75588 1.3575 8.02422C2.08917 7.29172 3.26833 7.29172 5.625 7.29172H12.2917C14.6483 7.29172 15.8275 7.29172 16.5592 8.02422C17.2917 8.75588 17.2917 9.93505 17.2917 12.2917C17.2917 14.6484 17.2917 15.8276 16.5592 16.5592C15.8275 17.2917 14.6483 17.2917 12.2917 17.2917H5.625C3.26833 17.2917 2.08917 17.2917 1.3575 16.5592C0.625 15.8276 0.625 14.6484 0.625 12.2917Z"
                        stroke="#404040" stroke-width="1.25"/>
                    <path
                        d="M8.95833 10.625V13.9583M3.95833 7.29167V5.625C3.95833 4.29892 4.48511 3.02715 5.42279 2.08947C6.36048 1.15178 7.63225 0.625 8.95833 0.625C10.2844 0.625 11.5562 1.15178 12.4939 2.08947C13.4315 3.02715 13.9583 4.29892 13.9583 5.625V7.29167"
                        stroke="#404040" stroke-width="1.25" stroke-linecap="round"/>
                  </svg>
                </div>
                <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Введите пароль"
                    disabled={loading}
                />
                <button
                    className="password-toggle"
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </button>
              </div>
            </div>

            <div className="mb-3 form-check">
              <input type="checkbox" className="form-check-input" id="termsCheck" checked={termsCheck}
                     onChange={(e) => setTermsCheck(e.target.checked)} required/>
              <label className="form-check-label" htmlFor="termsCheck">
                Я соглашаюсь с <a
                  href="https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2F8%2FztJGoMmoPMaWFoCkzhqQ32on%2F%2Fg5qpV%2BagIwb%2BJq6izrxOn%2FFbQFIlY3FfOfXMq%2FJ6bpmRyOJonT3VoXnDag%3D%3D&name=Лицензионный%20договор.docx&nosw=1"
                  style={{color: '#3745AF'}}>правилами использования платформой</a>
              </label>
            </div>
            <button
                type="submit"
                className="btn btn-primary-filled w-100"
                disabled={loading || !email || !password || !termsCheck}
            >
              {loading ? 'Входим...' : 'Войти'}
            </button>
            <div className="text-center mt-3">
              <span style={{color: '#777777'}}>Забыли пароль? </span>
              <a href="/forgot-password" style={{color: '#1E2C96'}}
                 onClick={() => navigate('/forgot-password')}>Восстановить</a>
            </div>
          </form>
        </div>
        <div className="login-footer">
          <p>Ещё не заключили договор? <a href="https://partner-leeds.ru/" className="login-link">Свяжитесь с нами,
            оставив заявку на сайте</a></p>
        </div>
      </div>
  );
};

export default MobileLoginForm;
